import { CartSubscription, WishlistSubscription, } from '../../common/event-bus/EventSubscription';
import AsyncTooltip from './ActionIcons/MyAccountTooltip/AsyncTooltip';
export var ACTION_ITEMS = [
    {
        // INFO: We are using the same ids to trick React into
        // thinking that those items are the same
        id: 'userAccount',
        icon: 'Account',
        label: 'h24_register',
        url: 'h24_register_url',
        Tooltip: AsyncTooltip,
        auth: false,
    },
    {
        id: 'userAccount',
        icon: 'Account',
        label: 'h24_my_account',
        url: 'h24_my_overview_url',
        Tooltip: AsyncTooltip,
        auth: true,
    },
    {
        id: 'wishlist',
        icon: 'Wishlist',
        label: 'h24_wishlist',
        url: 'h24_wishlist_url',
        Subscription: WishlistSubscription,
    },
    {
        id: 'cart',
        icon: 'Cart',
        label: 'h24_cart',
        url: 'h24_cart_url',
        Subscription: CartSubscription,
        countThreshold: 0,
    },
];
export var PAYBACK_ACTION_ITEM = {
    id: 'payback',
    icon: 'Payback',
    label: 'h24_payback',
    url: 'h24_payback_page_url',
    desktopOnly: true,
};
